module.exports = "<div class=\"trash\">\n    <fa name=\"trash\" style=\"position: absolute;top:50%;left:50%;transform:translate(-50%,-50%);\"></fa>\n</div>"